import { parseBroker } from '~Api/Broker/parsers';
import IHubspotBroker from './IHubspotBroker';
import StatusEnum from '~Api/HubspotBroker/StatusEnum';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseHubspotBroker(raw: any): IHubspotBroker {
    return {
        broker: parseBroker(raw.broker),
        brokerUuid: raw.brokerUuid,
        contactId: raw.contactId,
        errorMessage: raw.errorMessage,
        modifiedTime: raw.modifiedTime,
        status: raw.status as StatusEnum,
        syncedTime: raw.syncedTime,
        uuid: raw.uuid,
    };
}
